import { useEffect, useState, useRef} from "react";
import DataTable from "../../../Components/DataTable/DataTable";
import { ButtonAdd, ButtonEdit} from "../../../Components/Button/Button";
import Loading from "../../../Components/Loading/Loading";
import {useRecoilValue, useRecoilState} from 'recoil';
import { userData } from "../../../DataContext/DataContext";
import { AlertError } from "../../../Components/AlertDialog/AlertDialog";
import axios from "axios";
import { authorization, UrlApi} from "../../../UrlApi/UrlApi";
import Card from '@mui/material/Card';
import EditAssignPermissions from "./EditAssignPermissions";

function AssignPermissions(){
    const [openDialogformEdit, setOpenDialogFormEdit] = useState(false);
    const [openDialogformAdd, setOpenDialogFormAdd] = useState(false);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(50);
    const user = useRecoilValue(userData);

    const [roleGroupData, setRoleGroupData] = useState([]);
    const [roleGroupId, setRoleGroupId] = useState("");
    const [roleGroupName, setRoleGroupName] = useState("");

    const getData = async () => {
      setLoading(true);
      await axios.post(UrlApi+'get_role_group_data', {}, authorization).then((res)=>{
        res.data.map((item, index)=>{
          item.list_no = index + 1;
        });
        setRoleGroupData(res.data);
        setLoading(false);
      }).catch((err)=>{
        setLoading(false);
        AlertError(err);
      });

  };

    useEffect(()=>{
      getData();
    }, []);

    const columns = [
        {
          title: "ลำดับ",
          field: "list_no",
          filtering: false,
          headerStyle: {
            width: 2,
            maxWidth: 2,
          },
          cellStyle: { width: 2, maxWidth: 2 },
        },
        {
          title: "เปิด",
          field: "value",
          filtering: false,
          export: false,
          headerStyle: {
            width: 2,
            maxWidth: 2,
          },
          cellStyle: { width: 2, maxWidth: 2 },
          render: (rowData )=><ButtonEdit onClick={()=>{
            setRoleGroupId(rowData.value);
            setRoleGroupName(rowData.label);
            setOpenDialogFormEdit(true);
          }}/>
        },
        {
          title: "กลุ่มสิทธิ์",
          field: "label",
          
        },
    ];

    const HeaderPage = () => {
      return (
        <>
          <div style={{paddingTop: '10px'}}>
            <label style={{marginLeft: "10px", marginTop: "10px", fontSize: '18px'}}>
              กำหนดสิทธิ์การใช้งาน
            </label>
          </div>
        </>
      );
    };

    return (
        <>        
            <Card variant="outlined" style={{paddingLeft: '10px', paddingRight: '10px', borderRadius: '10px'}}>
                {HeaderPage()}
                <DataTable 
                    exportButton={false}              
                    columns={columns}
                    data={roleGroupData}
                    width="100%"
                    countRowData={roleGroupData.length}
                    pageSize={pageSize}
                />
            </Card>       
            {openDialogformEdit && <EditAssignPermissions 
                                      onCancel={()=>setOpenDialogFormEdit(false)} 
                                      open={openDialogformEdit}
                                      roleGroupId={roleGroupId}
                                      roleGroupName={roleGroupName}
                                    />}
    
            <Loading open={loading} />
        </>
    );
}

export default AssignPermissions;